import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import { Events, Programs } from "@/pages/EventsPrograms";
import { Donate, DonateSuccess } from "@/pages/Donate";
import { Volunteer, Membership, Nominate, Contact, Sponsorship } from "@/pages/Forms";
import { Gallery, Blog, BlogPost, Reports, Resources } from "@/pages/Content";
import { Shop, ProductDetail, Cart, ShopCheckout, ShopSuccess } from "@/pages/Shop";
import AdminApp, { AdminLogin } from "@/pages/Admin";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/events" element={<Events />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donate/success" element={<DonateSuccess />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/nominate" element={<Nominate />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/sponsorship" element={<Sponsorship />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/checkout" element={<ShopCheckout />} />
              <Route path="/shop/success" element={<ShopSuccess />} />
              <Route path="/shop/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminApp />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
